module.exports = __webpack_public_path__ + "img/krathong_8.6dce03f4.png";